__webpack_require__.p = "/bizx-smart/ahnaf-farm-house-v2/";